import React from 'react'
import styles from '../../styles.module.css'


const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const GRADES = [
  { key: 'total', label: 'Всего',    staff: 'staffTotal', list: 'listTotal' },
  { key: 'g5',    label: '5 класс',  staff: 'staff5',     list: 'list5' },
  { key: 'g6',    label: '6 класс',  staff: 'staff6',     list: 'list6' },
  { key: 'g7',    label: '7 класс',  staff: 'staff7',     list: 'list7' },
  { key: 'g8',    label: '8 класс',  staff: 'staff8',     list: 'list8' },
  { key: 'g9',    label: '9 класс',  staff: 'staff9',     list: 'list9' },
  { key: 'g10',   label: '10 класс', staff: 'staff10',    list: 'list10' },
  { key: 'g11',   label: '11 класс', staff: 'staff11',    list: 'list11' },
]

const SOCIAL_BEFORE = [
  { key: 'orphans',     label: 'Количество детей-сирот без оставшихся без попечения родителей', field: 'orphansCount' },
  { key: 'military',    label: 'Количество детей военнослужащих',                                field: 'militaryChildren' },
  { key: 'lawEnf',      label: 'Количество детей работников силовых ведомств',                   field: 'lawEnforcementChildren' },
]

const SVO = [
  { key: 'svoTotal',   label: 'Всего',                       field: 'svoTotal' },
  { key: 'svoWounded', label: 'Получивших ранения, увечья',  field: 'svoWounded' },
  { key: 'svoDead',    label: 'Погибших',                    field: 'svoDead' },
]

const HEALTH = [
  { key: 'health1', label: 'Количество детей с 1 группой здоровья',  field: 'health1' },
  { key: 'health2', label: 'Количество детей со 2 группой здоровья', field: 'health2' },
  { key: 'health3', label: 'Количество детей с 3 группой здоровья',  field: 'health3' },
]

const TOTAL_COLS = GRADES.length * 2 + SOCIAL_BEFORE.length + SVO.length + HEALTH.length


const SummaryTable = ({ row }) => {
  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>Сведения об обучающихся</th>
          <th className={styles.titleRight}>Форма №4/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №1</th>
        </tr>
        <tr>
          {GRADES.map(g => <th key={g.key} colSpan={2}>{g.label}</th>)}
          {SOCIAL_BEFORE.map(s => (
            <th key={s.key} rowSpan={2} className={styles.vertical}>{s.label}</th>
          ))}
          <th colSpan={SVO.length}>Количество детей участников СВО</th>
          {HEALTH.map(h => (
            <th key={h.key} rowSpan={2} className={styles.vertical}>{h.label}</th>
          ))}
        </tr>
        <tr>
          {GRADES.map(g => (
            <React.Fragment key={g.key}>
              <th className={styles.vertical}>По штату</th>
              <th className={styles.vertical}>По списку</th>
            </React.Fragment>
          ))}
          {SVO.map(s => <th key={s.key} className={styles.vertical}>{s.label}</th>)}
        </tr>
      </thead>
      <tbody>
        <tr>
          {GRADES.map(g => (
            <React.Fragment key={g.key}>
              <td>{fmt(row[g.staff])}</td>
              <td>{fmt(row[g.list])}</td>
            </React.Fragment>
          ))}
          {SOCIAL_BEFORE.map(s => <td key={s.key}>{fmt(row[s.field])}</td>)}
          {SVO.map(s => <td key={s.key}>{fmt(row[s.field])}</td>)}
          {HEALTH.map(h => <td key={h.key}>{fmt(row[h.field])}</td>)}
        </tr>
      </tbody>
    </table>
  )
}

export default SummaryTable
